
import { INDIA_STATE_DISTRICTS } from '@/data/state-districts';
import { INDIA_STATES_TAMIL } from '@/data/states';
import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-event-creation',
  templateUrl: './event-creation.component.html',
  styleUrl: './event-creation.component.scss'
})
export class EventCreationComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  participantsOptions: number[][] = [];
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      [{ header: [1, 2, 3, false] }],
      [{ color: [] }, { background: [] }],
      ['clean']
    ]
  };
  imagePreviews: string[] = [];

  minParticipantsOptions: number[][] = [];
  maxParticipantsOptions: number[][] = [];

  discountApplyOptions: number[][] = [];
  statesList = INDIA_STATES_TAMIL;
  districtList: any[] = [];

  mapSrc: string | null = null;
  mainEventDetails: any[] = [];
  submitted = false;
  eventId: number = 0;
  isEdit: boolean = false;
  eventDetails: EventBookingDetails;
  currentDate: string = '';
  currentBookedCount: number = 0;

  registrationOpenMin: string = '';
  registrationOpenMax: string = '';

  registrationCloseMin: string = '';
  registrationCloseMax: string = '';
  bookingCountError: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private configService: ConfigService) {
  }

  eventForm = new UntypedFormGroup({
    eventId: new UntypedFormControl(0),
    eventName: new UntypedFormControl('', Validators.required),
    emailId: new UntypedFormControl(""),
    contactEmail: new UntypedFormControl(""),
    contactPhone: new UntypedFormControl(""),
    eventOrganizer: new UntypedFormControl(""),

    eventDate: new UntypedFormControl('', Validators.required),
    startDate: new UntypedFormControl('', Validators.required),
    endDate: new UntypedFormControl('', Validators.required),

    startTime: new UntypedFormControl('', Validators.required),
    endTime: new UntypedFormControl('', Validators.required),

    eventVenue: new UntypedFormControl('', Validators.required),
    eventStatus: new UntypedFormControl(""),
    foodOption: new UntypedFormControl(''),

    paypalId: new UntypedFormControl(''),
    venmoId: new UntypedFormControl(''),

    json64Data: new UntypedFormControl(''),
    jsonType: new UntypedFormControl(''),

    eventLogoData: new UntypedFormControl(''),
    fileType: new UntypedFormControl(''),

    eventTicketData: new UntypedFormControl(''),
    eventType: new UntypedFormControl(''),
    buffet: new UntypedFormControl(null),
    ticketPrefix: new UntypedFormControl('', Validators.required),
    priceCategories: new UntypedFormControl([]),
    bookingCount: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(1)
    ]),
    volunteerBookingCount: new UntypedFormControl(0, [
      Validators.required,
      Validators.min(1)
    ]),
    volunteerWhatsappGroupLink: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/^(https?:\/\/)?(chat\.whatsapp\.com\/[A-Za-z0-9]+|wa\.me\/\d+|api\.whatsapp\.com\/send\?phone=\d+|whatsapp\.com\/channel\/[A-Za-z0-9]+)$/)
    ]),
    mapEmbeddedLink: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/^(https?:\/\/)?(www\.)?(google\.[a-z.]{2,6}\/maps|maps\.app\.goo\.gl|goo\.gl\/maps|maps\.google\.com)\/.+$/)
    ]),

    whatsappGroupLink: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/^(https?:\/\/)?(chat\.whatsapp\.com\/[A-Za-z0-9]+|wa\.me\/\d+|api\.whatsapp\.com\/send\?phone=\d+|whatsapp\.com\/channel\/[A-Za-z0-9]+)$/)
    ]),
    state: new UntypedFormControl('', Validators.required),
    city: new UntypedFormControl('', Validators.required),

    termsAndCondition: new UntypedFormControl('', Validators.required),
  });

  ngOnInit(): void {
    const storedId = localStorage.getItem('eventId');

    if (storedId) {
      this.eventId = Number(atob(storedId));
    } else {
      this.eventId = 0;
    }

    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0];

    // Default (no past date allowed)
    this.registrationOpenMin = this.currentDate;
    this.registrationCloseMin = this.currentDate;

    if (this.eventId === 0) {
      // Set readonly event name
      this.eventForm.patchValue({
        eventName: "வாழ்வை மாற்றும் வேல் மாறல்"
      });
      this.loadDistricts("Tamil Nadu");
    } else {
      this.eventDetailsGetById();
      this.isEdit = true;
    }
    this.eventForm.get('eventDate')?.valueChanges.subscribe(() => this.validateRegistrationDates());
    this.eventForm.get('startDate')?.valueChanges.subscribe(() => this.validateRegistrationDates());
    this.eventForm.get('endDate')?.valueChanges.subscribe(() => this.validateRegistrationDates());

  }

  loadDistricts(stateValue: string) {
    this.districtList = INDIA_STATE_DISTRICTS[stateValue] || [];
    this.eventForm.get('city')?.setValue(""); // reset
  }

  submitForm() {
    if(this.isEdit){
    this.validateBookingCount();
    }
    if (this.eventForm.invalid) {
      this.eventForm.markAllAsTouched();
      return;
    }
    this.saveEventDetails()
  }

  validateBookingCount() {
  const bookingCount = this.eventForm.get('bookingCount')?.value || 0;
  
  if (bookingCount < this.currentBookedCount) {
    this.bookingCountError = true;
    this.eventForm.get('bookingCount')?.setErrors({ minBooked: true });
  } else {
    this.bookingCountError = false;
    // Remove the custom error if valid
    const errors = this.eventForm.get('bookingCount')?.errors;
    if (errors) {
      delete errors['minBooked'];
      if (Object.keys(errors).length === 0) {
        this.eventForm.get('bookingCount')?.setErrors(null);
      }
    }
  }
}
  

  get f() {
    return this.eventForm.controls;
  }

  onSelectEventDate(event: any): void {
    let eventDateValue: string = '';

    // When selected by user
    if (event?.target?.value) {
      eventDateValue = event.target.value;
    }
    // When coming from patchValue
    else if (typeof event === 'string') {
      eventDateValue = event;
    }

    if (!eventDateValue) {
      return; // Do nothing
    }

    const eventDate = new Date(eventDateValue);
    const eventDateStr = eventDate.toISOString().split('T')[0];

    // Max open date = event - 1 day
    const openMax = new Date(eventDate);
    openMax.setDate(openMax.getDate() - 1);

    this.registrationOpenMin = this.currentDate;
    this.registrationOpenMax = openMax.toISOString().split('T')[0];

    this.registrationCloseMin = this.currentDate;
    this.registrationCloseMax = eventDateStr;

    // 👇 Only clear if EMPTY (update mode safe)
    const startDate = this.eventForm.get('startDate')?.value;
    const endDate = this.eventForm.get('endDate')?.value;

    const patchObj: any = {};

    if (!startDate) patchObj.startDate = '';
    if (!endDate) patchObj.endDate = '';

    if (Object.keys(patchObj).length > 0) {
      this.eventForm.patchValue(patchObj);
    }
  }




  toUppercase(controlName: string) {
    const value = this.eventForm.get(controlName)?.value || '';
    this.eventForm.get(controlName)?.setValue(
      value.replace(/[^A-Za-z]/g, '').toUpperCase(),
      { emitEvent: false }
    );
  }


  toEpochWithDateAndTime(time24: string): string {
    let [hour, minute] = time24.split(':').map(Number);

    const ampm = hour >= 12 ? 'PM' : 'AM';

    if (hour === 0) {
      hour = 12; // midnight → 12 AM
    } else if (hour > 12) {
      hour = hour - 12;
    }

    const hourStr = hour.toString().padStart(2, '0');
    const minuteStr = minute.toString().padStart(2, '0');

    return `${hourStr}:${minuteStr} ${ampm}`;
  }



  validateRegistrationDates() {

    const eventDate = new Date(this.eventForm.get('eventDate')?.value);
    const startDate = new Date(this.eventForm.get('startDate')?.value);
    const endDate = new Date(this.eventForm.get('endDate')?.value);

    if (!eventDate || !startDate || !endDate) return;

    const startCtrl = this.eventForm.get('startDate');
    const endCtrl = this.eventForm.get('endDate');

    let startErrors: any = startCtrl?.errors || {};
    let endErrors: any = endCtrl?.errors || {};


    if (startDate >= eventDate) {
      startErrors.startGreaterEvent = true;
    } else {
      delete startErrors.startGreaterEvent;
    }

    if (endDate >= eventDate) {
      endErrors.endGreaterEvent = true;
    } else {
      delete endErrors.endGreaterEvent;
    }


    if (startDate >= endDate) {
      startErrors.startGreaterEnd = true;
    } else {
      delete startErrors.startGreaterEnd;
    }

    // Apply or clear errors
    startCtrl?.setErrors(Object.keys(startErrors).length ? startErrors : null);
    endCtrl?.setErrors(Object.keys(endErrors).length ? endErrors : null);
  }




  saveEventDetails() {
    // Store original form values so we can restore on error
    const originalValues = { ...this.eventForm.value };

    // Convert dates to epoch (13-digit)
    const payload = {
      ...this.eventForm.value,
      eventDate: this.convertToEpoch(originalValues.eventDate),

      startDate: this.toEpoch(originalValues.startDate),
      endDate: this.toEpoch(originalValues.endDate),

      startTime: this.toEpochWithDateAndTime(originalValues.startTime),
      endTime: this.toEpochWithDateAndTime(originalValues.endTime),
    };
    console.log(payload)
    this.spinner.show();
    const apiCall = this.isEdit
      ? this.appService.updateEventDetails(payload)
      : this.appService.saveEventDetails(payload);
    apiCall.pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (res) => {
          const action = this.isEdit ? "updated" : "saved";
          this.toastr.success(`Event details ${action} successfully.`,
            "",
            { enableHtml: true }
          );
          this.router.navigate(['/main/event-list-table']);
        },
        error: (err) => {
          console.error("API Failed", err);

          // Restore original form values if API fails
          this.eventForm.patchValue(originalValues);

          this.toastr.error("Unable to save event details. Try again!");
        }
      });
  }


  convertToEpoch(dateString: string): number {
    if (!dateString) return 0;

    const date = new Date(dateString);
    return date.getTime(); // 13-digit epoch (milliseconds)
  }

  toEpoch(date: string): number {
    if (!date) return 0;
    return new Date(date).getTime();   // 13-digit epoch
  }


  eventDetailsGetById() {
    this.appService.eventDetailsGetById(this.eventId)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (res) => {
          this.loadDistricts(res.state)
          this.eventDetails = res;
          console.log(this.eventDetails)
          const updatedValues = {
            ...res,
            eventDate: this.convertEpochToDateString(res.eventDate),
            startDate: this.convertEpochToDateString(res.startDate),
            endDate: this.convertEpochToDateString(res.endDate),
            startTime: this.convert12To24(res.startTime),
            endTime: this.convert12To24(res.endTime)
          };
          this.eventForm.patchValue(updatedValues);
          this.currentBookedCount = updatedValues.bookedCount
          this.onSelectEventDate(updatedValues.eventDate)
        },
        error: (err) => {
          this.toastr.error("Unable to getting event details. Try again!");
        }
      });
  }

  convertEpochToDateString(epoch: number | null): string {
    if (!epoch) return '';

    const date = new Date(epoch); // epoch is in milliseconds
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${yyyy}-${mm}-${dd}`;
  }

  convert12To24(time12: string): string {
    const [time, modifier] = time12.split(" ");  // "10:54", "PM"
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours = hours + 12;
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const hh = hours.toString().padStart(2, "0");
    const mm = minutes.toString().padStart(2, "0");

    return `${hh}:${mm}`;   // e.g. "22:54"
  }


  allowNumbersOnly(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.indexOf(event.key) !== -1) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }



  ngOnDestroy(): void {
    localStorage.removeItem("eventId");
  }

}
